import { adminHttpClient } from '../commons/adminHttpClient'
import SubscriptionFrequency from '../adminSignUp/common/subscriptionFrequency'

export type SubscriptionFeesResponse = {
  setupFee: number
  monthlyFee: number
  employeeFee: number
  proratedMonthlyFee: number
  proratedEmployeeFee: number
  totalEmployeeFee: number
  todaysTotal: number
  frequency: SubscriptionFrequency
  minimumSeats: number
  seatNumber: number
}

export type SubscriptionFeesRequest = {
  planCode: string
  productId: number
  seatNumber: number
}

const getSubscriptionFees = (
  planCode: string,
  productId: number,
  seatNumber: number,
): Promise<SubscriptionFeesResponse> => {
  const request: SubscriptionFeesRequest = {
    planCode: planCode,
    productId: productId,
    seatNumber,
  }
  return adminHttpClient.get(`/Subscriptions/SubscriptionFees`, request)
}

export default getSubscriptionFees
